import React, { useState, useEffect } from 'react'

import { useTranslation } from 'react-i18next'

import { Button } from '@/Atomic/Molecules/Button'
import { Modal } from '@/Atomic/Organisms/Modal'
import './SaveAsFilterModal.scss'

export interface SaveAsFilterModalProps {
  isOpen: boolean
  onClose: () => void
  onSave: (filterName: string) => void | Promise<void>
  title?: string
  buttonText?: string
}

//// FIXUP: TRY TO REMOVE MODAL FROM DOM WHEN NOT NEEDED
export const SaveAsFilterModal: React.FC<SaveAsFilterModalProps> = ({
  isOpen,
  onClose,
  onSave,
  title,
  buttonText,
}) => {
  const { t } = useTranslation()
  const [filterName, setFilterName] = useState('')
  const [isSaved, setIsSaved] = useState(false)

  // Reset state when modal closes to ensure clean state on next open
  // Parent component controls isOpen prop - we need to sync our local state when it changes
  useEffect(() => {
    if (!isOpen) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setFilterName('')
      setIsSaved(false)
    }
  }, [isOpen])

  const handleSave = async () => {
    if (filterName.trim()) {
      await onSave(filterName.trim())
      setIsSaved(true)
    }
  }

  const handleClose = () => {
    // State reset is handled by useEffect when isOpen becomes false
    // This just calls the parent's onClose callback
    onClose()
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && filterName.trim()) {
      handleSave()
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      className="save-as-filter-modal"
    >
      <Modal.Header title={title || t('advancedSearch.saveAsFilter')} />
      <Modal.Body>
        <div className="save-as-filter-form">
          <label className="save-as-filter-label">
            {t('advancedSearch.filterName')}
          </label>
          <input
            type="text"
            className="save-as-filter-input"
            value={filterName}
            onChange={(e) => setFilterName(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={t('advancedSearch.filterNamePlaceholder')}
            autoFocus
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outlined" onClick={handleClose}>
          {t('common.cancel')}
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={!filterName.trim() || isSaved}
        >
          {isSaved
            ? t('advancedSearch.filterSaved')
            : buttonText || t('advancedSearch.saveAndApply')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
